import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClockIcon } from 'DesignSystem/Icons';
import { IconButton } from 'DesignSystem/Buttons';
import SignatureAuditModal from './SignatureAuditModal';
import { getAuditHistory, getAuditHistoryFromShareKey } from './SignatureAuditButtonActions';

class SignatureAuditButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isAuditModalVisible: false,
    };

    this.showDeclineModal = this.showDeclineModal.bind(this);
    this.hideDeclineModal = this.hideDeclineModal.bind(this);
  }

  componentDidUpdate() {
    if (this.state.isAuditModalVisible) {
      if (this.props.shareKey) {
        this.props.getAuditHistoryFromShareKey(this.props.shareKey);
      } else {
        this.props.getAuditHistory(
          this.props.documentType,
          this.props.sessionId,
          this.props.userId,
          this.props.userToken,
        );
      }
    }
  }

  showDeclineModal() {
    this.props.onClick();
    this.setState({
      isAuditModalVisible: true,
    });
  }

  hideDeclineModal() {
    this.setState({
      isAuditModalVisible: false,
    });
  }

  render() {
    return (
      <Fragment>
        <IconButton
          rel="tooltip"
          title="View Signature History"
          className="btn signature-audit-btn"
          disabled={this.props.disabled}
          icon={(<ClockIcon height={17} width={17} />)}
          onClick={this.showDeclineModal}
        />
        <SignatureAuditModal
          closeModal={this.hideDeclineModal}
          isOpen={this.state.isAuditModalVisible}
        />
      </Fragment>
    );
  }
}

SignatureAuditButton.defaultProps = {
  disabled: false,
  documentType: '',
  onClick: () => null,
  sessionId: '',
  shareKey: '',
  userId: null,
  userToken: '',
};

SignatureAuditButton.propTypes = {
  disabled: PropTypes.bool,
  documentType: PropTypes.string,
  getAuditHistory: PropTypes.func.isRequired,
  getAuditHistoryFromShareKey: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  sessionId: PropTypes.string,
  shareKey: PropTypes.string,
  userId: PropTypes.string,
  userToken: PropTypes.string,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    getAuditHistory,
    getAuditHistoryFromShareKey,
  }, dispatch)
);

export default ReactRedux.connect(
  null,
  mapDispatchToProps,
)(SignatureAuditButton);



// WEBPACK FOOTER //
// ./src-react/SignatureAuditButton/index.jsx